import {RailsPdtConstants} from './RailsPdtConstants';
import RailsPdtReviewEvent from '../PdtModel/PdtEvents/RailsPdtReviewEvent';
import {pushPdtData} from '../PdtAnalytics';

export default class RailsPdtReviewHelper {
  static trackPageLoad(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.LOAD_PAGE;
      const pdtObject = new RailsPdtReviewEvent(pdtData).trackReviewEvent();
      pdtObject.user_flow_blocker.blocking_reason = data?.listingErrorCodeString;
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackPageExit(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.EXIT_PAGE;
      const pdtObject = new RailsPdtReviewEvent(pdtData).trackReviewEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackBackPressed(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.CLICK_BACK;
      const pdtObject = new RailsPdtReviewEvent(pdtData).trackReviewEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackPerformHold(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.ReviewEventAction.CLICK_PAY;
      const pdtObject = new RailsPdtReviewEvent(pdtData).trackReviewEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }
}
